import React from 'react';
import NoAvatar from '@assets/images/no-avatar.png';
import './styles.scss';

interface ProfileImageProps {
  avatar: string;
}

const ProfileImage: React.FC<ProfileImageProps> = ({ avatar }) => {
  return (
    <div>
      {avatar ? (
        <img
          width="300"
          height="300"
          className="profile-img"
          src={avatar}
          alt={avatar}
        />
      ) : (
        <img
          width="300"
          height="300"
          className="profile-img"
          src={NoAvatar}
          alt="No avatar"
        />
      )}
    </div>
  );
};

export default ProfileImage;
